import querystring from 'query-string';

import { IMG_PROXY_PATH } from 'config/envVariable';

export function convertProxyImgUrl({ url, width, height, resizeWidth, resizeHeight }) {
    const { url: pureUrl, query } = querystring.parseUrl(url);
    const { bucket, fileName } = desctureS3URL(pureUrl);
    if (bucket === 'assets.fevercdn.com' && fileName) {
        return getProxyImgUrl({
            bucket,
            fileName,
            width,
            height,
            resizeWidth,
            resizeHeight,
            additionalQueryObj: query
        });
    }
    return url;
}

export function getProxyImgUrl({
    fileName,
    bucket,
    width = '',
    height = '',
    resizeWidth = '',
    resizeHeight = '',
    additionalQueryObj = {}
}) {
    const qsObj = { ...additionalQueryObj, filepath: fileName, bucket };
    if (width || height) {
        qsObj.crop = `${width}x${height}`;
    }
    if (resizeWidth || resizeHeight) {
        qsObj.resize = `${resizeWidth}x${resizeHeight}`;
    }
    const qs = querystring.stringify(qsObj);
    return `${IMG_PROXY_PATH}?${qs}`;
}

function desctureS3URL(url) {
    try {
        // eslint-disable-next-line no-useless-escape
        const result = url.match(/https:\/\/?([^\/]*)\/(.*)/);
        if (result) {
            const [, bucket = '', fileName = ''] = result;
            return { bucket, fileName };
        }
        return {};
    } catch (error) {
        return {};
    }
}
